import React from "react";
import {
    Button,
    Col,
    Container,
    Form,
    Jumbotron,
    Row
} from "react-bootstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { withTranslation } from "react-i18next";
import CamplaCoreService from "../../services/CamplaCoreService";
import ValidationHelper from "../../helpers/ValidationHelper";
import APIErrorHelper from "../../helpers/APIErrorHelper";

class Login extends React.Component {
    constructor(props) {
        super(props);

        this.validationDefinition = {
            email: {
                defaultValue: "",
                rule: (value) => ValidationHelper.isEmail(value) && value.length > 0,
            },
            password: {
                defaultValue: "",
                rule: (value) => ValidationHelper.isString(value) && value.length > 0,
            },
            token: {
                defaultValue: "",
                initValid: true,
                rule: (value) => ValidationHelper.isString(value) && (/^[0-9]{6}$/.test(value))
            }
        };

        this.state = {
            apiError: "",
            isAuthenticated: true,
            authenticatedUser: null,
            loginLocked: false,
            mfa: null,
            validation: ValidationHelper.getValidation(this.validationDefinition)
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    }

    async componentDidMount() {

    }

    componentWillUnmount() {

    }

    handleChange(event) {
        this.setState({
            validation: ValidationHelper.update(event, this.state.validation)
        });
    }


    async handleLogin(){
        if (this.state.validation._isValid) {
            const validatedData = ValidationHelper.getData(this.state.validation);
            try {
                if (this.state.mfa){
                    const mfaToken = this.state.mfa.token;
                    const email = this.state.mfa.email;
                    this.setState({ apiError: "", loginLocked: true });
                    const {token, identity, target} = await CamplaCoreService.internalLogin({
                        mfaToken,
                        email,
                        token: validatedData.token
                    });
                    CamplaCoreService.login(token, identity, target);
                    const isAuthenticated = await CamplaCoreService.isAuthenticated();
                    this.setState({
                        apiError: "",
                        loginLocked: false,
                        mfa: null,
                        isAuthenticated: isAuthenticated,
                        authenticatedUser: CamplaCoreService.getAuthenticatedUser()
                    });
                    if (isAuthenticated) this.props.onLoginUpdate();
                }else{
                    this.setState({ apiError: "", loginLocked: true, mfa: null });
                    const res = await CamplaCoreService.internalLogin(validatedData);
                    if (typeof res["mfaToken"] !== "undefined"){
                        this.setState({ apiError: "", loginLocked: false, mfa: {
                                token: res["mfaToken"],
                                email: validatedData.email
                            }});
                    }else if(typeof res["token"] !== "undefined"){
                        CamplaCoreService.login(res.token, res.identity, res.target);
                        const isAuthenticated = await CamplaCoreService.isAuthenticated();
                        this.setState({
                            apiError: "",
                            loginLocked: false,
                            mfa: null,
                            isAuthenticated: isAuthenticated,
                            authenticatedUser: CamplaCoreService.getAuthenticatedUser()
                        });
                        if (isAuthenticated) this.props.onLoginUpdate();
                    }else{
                        this.setState({ apiError: "", loginLocked: false, mfa: null });
                    }
                }
            } catch (err) {
                this.setState({
                    loginLocked: false,
                    mfa: null,
                    apiError: APIErrorHelper.getError(
                        err,
                        () => this.setState({apiError: ""}),
                        {
                            PRECONDITION_FAILED: "Login.Form.APIError.PreconditionFailed",
                            BAD_REQUEST: "Login.Form.APIError.BadRequest"
                        },
                        this.props.t
                    ),
                });
            }
        }
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <Container>
                    <Row className="mt-5">
                        <Col></Col>
                        <Col>
                            <Jumbotron className="pt-5">
                                <Row>
                                    <Col className="text-center">
                                        <img
                                            alt="Campla Logo"
                                            src="/images/logo/Logo-trans-128x128.png"
                                            height="100px"
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col>
                                        {this.state.apiError}
                                        {this.state.mfa ? (
                                            <Form.Group controlId="formLoginToken">
                                                <Form.Label>
                                                    {t(
                                                        "Login.Form.Token"
                                                    )}{" "}
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="token"
                                                    value={this.state.validation.token.value}
                                                    isInvalid={!this.state.validation.token.isValid}
                                                    onChange={this.handleChange}
                                                />
                                                <Form.Control
                                                    type="hidden"
                                                    isInvalid={
                                                        !this.state.validation.token.isValid
                                                    }
                                                />
                                            </Form.Group>
                                        ) : (
                                            <>
                                                <Form.Group controlId="formLoginUsername">
                                                    <Form.Label>
                                                        {t(
                                                            "Login.Form.Email"
                                                        )}{" "}
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="email"
                                                        value={this.state.validation.email.value}
                                                        isInvalid={!this.state.validation.email.isValid}
                                                        onChange={this.handleChange}
                                                    />
                                                    <Form.Control
                                                        type="hidden"
                                                        isInvalid={
                                                            !this.state.validation.email.isValid
                                                        }
                                                    />
                                                </Form.Group>
                                                <Form.Group controlId="formLoginPassword">
                                                    <Form.Label>
                                                        {t(
                                                            "Login.Form.Password"
                                                        )}{" "}
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="password"
                                                        name="password"
                                                        value={this.state.validation.password.value}
                                                        isInvalid={!this.state.validation.password.isValid}
                                                        onChange={this.handleChange}
                                                    />
                                                    <Form.Control
                                                        type="hidden"
                                                        isInvalid={
                                                            !this.state.validation.password.isValid
                                                        }
                                                    />
                                                </Form.Group>
                                            </>
                                        )}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="text-center">
                                        <Button
                                            onClick={() => this.handleLogin()}
                                            className="btn btn-green"
                                        >
                                            {t("Login.Form.AuthButton")}
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <hr />
                                    </Col>
                                </Row>
                                {window.authenticators.map(i => (
                                    <Row>
                                        <Col className="text-center">
                                            <Button
                                                onClick={() => CamplaCoreService.authenticate(i.loginLink)}
                                                className="btn btn-black"
                                            >
                                                {t("Login.Form.AuthButton")}: {i.name}
                                            </Button>
                                        </Col>
                                    </Row>
                                ))}
                            </Jumbotron>
                        </Col>
                        <Col></Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default withTranslation()(Login);
